import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from 'react';
import { cn } from '../lib/cn';

export type CheckboxProps = ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>;

export const Checkbox = forwardRef<ElementRef<typeof CheckboxPrimitive.Root>, CheckboxProps>(
  ({ className, ...rest }, ref) => (
    <CheckboxPrimitive.Root
      ref={ref}
      className={cn(
        'inline-flex h-5 w-5 items-center justify-center rounded-xs border border-border-strong bg-surface text-fg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-fg/30 data-[state=checked]:border-fg data-[state=checked]:bg-fg data-[state=checked]:text-white disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...rest}
    >
      <CheckboxPrimitive.Indicator>
        <Check className="h-3.5 w-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  ),
);
Checkbox.displayName = 'Checkbox';
